var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_vm._t("prefix"),_c('v-tooltip',_vm._b({attrs:{"color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},'v-tooltip',Object.assign({}, _vm.tooltipOptions),false),[_vm._t("tooltipContent")],2),_vm._t("suffix")],2)}
var staticRenderFns = []

export { render, staticRenderFns }